import { useState } from "react";
import PartySocket from "partysocket";
import usePartySocket from "partysocket/react";

import NoGame from './NoGame';
import Humanity from './Humanity';

function getGameElement( game ) {
	switch( game ) {
		case 'humanity':
			return Humanity;
		default:
			return NoGame;
	}
}

export default function Game( { room = 'default' } ) {
	const [ gameState, setGameState ] = useState( {
		game: null,
		players: [],
	} );

	const socket = usePartySocket( {
		room,
		onMessage( evt ) {
			setGameState( JSON.parse( evt.data ) );
		},
	} );

	const GameElement = getGameElement( gameState.game );
	return <GameElement socket={ socket } gameState={ gameState } setGameState={ setGameState } />;
}